// XPEN-3790: a line's number is its 1-based place in the report's lines, read when shown and
// never stored, so every screen gives the same number to the same line and a delete, add or
// move renumbers them all alike.

const sameLine = (candidate, line) => {
  if (candidate === line) return true;
  if (candidate?.line_id || line?.line_id) return Boolean(candidate?.line_id) && candidate.line_id === line?.line_id;
  return candidate?._view_id != null && candidate._view_id === line?._view_id;
};

// Removed lines are kept outside ListItem, but a line flagged deleted never takes a number,
// the same rule as the API (src/utils/line_numbers.py).
const activeLines = (listItems) => (Array.isArray(listItems) ? listItems.filter((line) => line && !line._is_deleted) : []);

/** The line's number in the report, or null when it is not one of its lines. */
export const lineNumberOf = (listItems, line) => {
  if (!line) return null;
  const index = activeLines(listItems).findIndex((candidate) => sameLine(candidate, line));
  return index >= 0 ? index + 1 : null;
};

// A submitted expense's lines carry its uid in `source`; older lines only its receipt checksum.
const cameFromExpense = (line, expense) => (line?.source?.id
  ? line.source.type === 'expense' && line.source.id === expense?.expense_uid
  : Boolean(expense?.checksum) && line?.checksum === expense.checksum);

/** The numbers of the lines an expense became once its report was submitted, in order. */
export const lineNumbersOfExpense = (listItems, expense) => (expense
  ? activeLines(listItems).reduce((numbers, line, index) => (cameFromExpense(line, expense) ? [...numbers, index + 1] : numbers), [])
  : []);

/** "Line 3", "Lines 3–4", "Lines 3–5, 8". */
export const formatLineNumbers = (numbers, t) => {
  if (!numbers?.length) return '';
  const runs = [];
  numbers.forEach((number) => {
    const run = runs[runs.length - 1];
    if (run && number === run[1] + 1) run[1] = number;
    else runs.push([number, number]);
  });
  const text = runs.map(([first, last]) => (first === last ? `${first}` : `${first}–${last}`)).join(', ');
  // Same tolerance as the approvals table's translate helper when no translator is passed.
  const word = t?.read?.(numbers.length === 1 ? 'line_number.line' : 'line_number.lines') || '';
  return `${word} ${text}`.trim();
};
